import { AlgoliaSearchService } from '@b2ag/search'
import OfferService from '@b2ag/offers/src/services/offer.service'
import algoliasearch from 'algoliasearch/lite'
import { AuthLocationStorage } from '@b2ag/auth'
import { accessTokenSource, createFrontAxiosClient } from '@b2ag/axios-client'
import { DiscountService } from '@b2ag/pricing/src/contexts/discount/discount.service'
import LegacyCartService from '@b2ag/cart/src/cart.service'
import { useLogger } from '@b2ag/utils/src/useLogger'
import { createShoppingListApiClient } from '@b2ag/legacy-shared-shopping-list-sdk'
import { getConfig } from '@b2ag/micro-front-tools'

export { productService } from '@b2ag/product/src/dependency-injection'

const cartApiHost = getConfig('CART_API_HOST')
const offerApiHost = getConfig('OFFER_API_HOST')
const discountApiHost = getConfig('DISCOUNT_API_HOST')
const searchAppId = getConfig('ALGOLIA_APP_ID')
const searchApiKey = getConfig('ALGOLIA_API_KEY')
const shoppingListApiHost = getConfig('SHOPPING_LIST_API_HOST')!

const logger = useLogger()

export const algoliaClient = algoliasearch(searchAppId, searchApiKey)
export const searchService = new AlgoliaSearchService(algoliaClient)
export const cartService = new LegacyCartService({ cartApiHost })
export const offerService = new OfferService(createFrontAxiosClient(offerApiHost))
export const discountService = new DiscountService({ discountApiHost })

export const locationStorage = import.meta.browser
  ? new AuthLocationStorage(localStorage)
  : { storeLocation: () => {}, afterLoginPath: '/' }

export const shoppingListApiClient = createShoppingListApiClient({
  shoppingListApiHost,
  useCartV2: true,
  accessTokenSource,
  logger,
})
